const timeoutError = new Error('Timeout');

export const promiseWithTimeout = <T>(promise: Promise<T>, timeoutMs: number) => {
  const promiseForTimeout = new Promise<T>((resolve, reject) => setTimeout(() => reject(timeoutError), timeoutMs));
  return Promise.race([promise, promiseForTimeout]);
};
